import React, { Component } from 'react';
import {
  Col, Button, DropdownButton, MenuItem,
  Alert, Image, Tabs, Tab,
  Modal, FormControl,
} from 'react-bootstrap';
import { browserHistory, Link, } from 'react-router';
import firebase from 'firebase';
import slug from 'slug';
import Dropzone from 'react-dropzone';
// import TinyMCE from 'react-tinymce';

/** COMPONENTS CUSTOM **/
import { APP_CONFIG } from './../../../boot.config';
import { TOOLS } from './../../../util/tools.global';
// import { MasterForm } from '../../Form/MasterForm';
// import { Input } from '../../Form/Input';
export class Settings extends Component{
  constructor(props){
    super(props);
    this.state = {
      isLoading : true,
      showModal : false,
      confirmDelete : false,
      action : this.props.action,
      apps : [],
      packages: this.props.packages,
      files: [],

      uid : this.props.currentUser.uid,
      appID : document.querySelector('[data-js="root"]').dataset.appid || null,
      company_name : APP_CONFIG.PROJECT_NAME,
      company_slogan_name : APP_CONFIG.PROJECT_SLOGAN,
      logoURL: this.props.logoURL || null,
      user_name : null,
      status : true,

      status_response : null,
      message_response : null
    }

    this.checkStatusResponse = this.checkStatusResponse.bind(this);
    this.checkStates = this.checkStates.bind(this);
    this.getPages = this.getPages.bind(this);
    this.resetCurrentState = this.resetCurrentState.bind(this);
    this.renderModal = this.renderModal.bind(this);
    this.requiredInput = TOOLS.requiredInput.bind(this);

    /*** FUNCTIONS AUXILIARES DO FORM ***/
    this.onLoadForm = this.onLoadForm.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.onUpdateForm = this.onUpdateForm.bind(this);
    this.onChangeForm = this.onChangeForm.bind(this);
    this._onChangeCompanyName = this._onChangeCompanyName.bind(this);
    this._onChangeUserName = this._onChangeUserName.bind(this);
    this.onChangeTiny = this.onChangeTiny.bind(this);

    /*** FUNCTIONS AUXILIARES DAS TABS **/
    this.changePackageDashboard = this.changePackageDashboard.bind(this);
    this.changePackageShop = this.changePackageShop.bind(this);
    this.changePackageSite = this.changePackageSite.bind(this);

    this.onDropFile = this.onDropFile.bind(this);
    this.onDropFileClick = this.onDropFileClick.bind(this);
    this.runUploadFiles = this.runUploadFiles.bind(this);

    /*** RENDER FUNCTIONS - TABS **/
    this.tabGeral = this.tabGeral.bind(this);
    this.tabLayout = this.tabLayout.bind(this);
    this.tabModules = this.tabModules.bind(this);
    this.tabExtras = this.tabExtras.bind(this);

    /*** RENDER FUNCTIONS - ACTIONS ***/
    this.actionNull = this.actionNull.bind(this);
    this._onChangeCompanyName = this._onChangeCompanyName.bind(this);
    this._onChangeSloganCompanyName = this._onChangeSloganCompanyName.bind(this);
    this.onChangeTiny = this.onChangeTiny.bind(this);

    /*** RENDER FUNCTIONS - ACTIONS ***/
    this.actionNull = this.actionNull.bind(this);
    this.renderAction = this.renderAction.bind(this);
  }

  componentWillMount(){
    // this.getPages();
    console.log('componentWillMount');
    if(this.props.action === 'edit' && this.props.appID){
      console.log('componentWillMount if edit ')
      this.setState({ appID : this.props.appID });
    }
  }

  componentDidMount(){
    console.log('User id -> ',this.state.uid);
    let _self=this;
  };//componentDidMount();

  componentWillReceiveProps(nextProps){
    console.log('componentWillReceiveProps ',nextProps);

    if(nextProps.action === 'new'){
      return this.resetCurrentState();
    }else if(nextProps.categoryID || nextProps.action === 'edit'){
      console.log('getPages to ',nextProps.action);
      console.log('getPages to ',nextProps);
      return this.getPages(nextProps.appID);
    }
  };//componentWillReceiveProps();

  checkStatusResponse(){
    const closeAlert = (e) => {
      if(e)
        e.preventDefault();
      this.setState({ status_response : null, message_response : null});
    };//closeAlert(e);
    if(this.state.status_response === true){
      setTimeout(() => {
        closeAlert();
      },4000);
      return (<Alert bsStyle={'success'} onDismiss={closeAlert.bind(this)}>{this.state.message_response}</Alert>);
    }

    if(this.state.status_response === false){
      setTimeout(() => {
        closeAlert();
      },4000);
      if(this.state.status === 'Rascunho'){
        return (<Alert className={'default'} onDismiss={closeAlert.bind(this)}>{this.state.message_response}</Alert>);
      }else if(this.state.status === 'requiredInput'){
        return (<Alert className={'warning'} onDismiss={closeAlert.bind(this)}>{this.state.message_response}</Alert>);
      }
      return (<Alert bsStyle={'danger'} onDismiss={closeAlert.bind(this)}>{this.state.message_response}</Alert>);
    }

    return null;
  };//checkStatusResponse();

  checkStates(){
    if(this.state.appID)
      this.setState({ appID : this.state.appID })

    console.log('checkStates exit();');
  };//checkStates();

  getPages(appID){
    // console.log('Init getPages ->',appID);
    if( appID ){
      // console.log('Getting appID ->',appID);
      // eslint-disable-next-line
      return this.state.apps.map((page) => {
        // eslint-disable-next-line
        if(page.appID === appID){
          this.setState({
            appID : page.appID,
            name : page.name,
            slug : page.slug,
            status: page.status
          });
        }else{
          return false;
        }
      });
      // firebase.database().ref('apps/'+appID).once('value')
      //   .then((res) => {
      //     console.log('getPage 1 res ',res.val().name);
      //   })
      //   .catch((err) => {
      //     console.log('getPage 1 err',err);
      //   })
    }
    this.setState({ isLoading : false });
  };//getPages();

  resetCurrentState(){
    console.log('resetCurrentState();');
    return this.setState({
      showModal : false,
      confirmDelete : false,
      action : this.props.action,

      uid : this.props.currentUser.uid,
      appID : null,
      name : null,
      slug : null,
      status : true,

      status_response : null,
      message_response : null
    });
  };//resetCurrentState();

  renderModal(){
    let
      pageTitle = this.state.name;
    const close = () => {
      this.setState({ showModal : false });
    }
    const confirm = () => {
      firebase.database().ref('apps/'+this.state.appID)
        .remove()
        .then(() => {
          this.setState({
            isLoading : false,
            showModal : false,
            confirmDelete : false,
            status : 'Deletado',
            status_response : true,
            message_response : '{ ' + this.state.name + ' } deletado com sucesso!'
          });
        })
        .catch((err) => {
          this.setState({
            isLoading : false,
            showModal : false,
            confirmDelete : true,
            status : 'Error',
            status_response : false,
            message_response : 'Ocorreu uma falha ao tentar deletar { ' + this.state.name + ' } - '+err.message
          });
        });
    }
    return (
      <Modal show={this.state.showModal} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>Deseja realmente excluir {pageTitle}?</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Link to={'/dashboard/apps'} onClick={close.bind(this)} className={'btn btn-danger'}>Cancelar</Link>
          <Button onClick={confirm.bind(this)} bsStyle={'success'}>Confirmar</Button>
        </Modal.Footer>
      </Modal>
    );
  };//renderModal();

  /*** FUNCTIONS AUXILIARES DO FORM ***/
  onLoadForm(){
    console.log('onLoadForm();');
  };//onLoadForm(e);
  onSubmitForm(e) {
    e.preventDefault();
    let required = document.getElementsByClassName('required');
    if(required.length > 0){
      this.setState({
        isLoading : true,
        status : 'requiredInput',
        status_response : false,
        message_response : 'Por favor, preencha todos os campos corretamente.'
      });
      return false;
    }else{
      const appID = this.refs.appID.value;
      const dataInsert = {
        uid : this.state.uid,
        appID : appID,
        name : this.state.name,
        slug : this.state.slug,
        status: true
      };
      firebase.database().ref('apps/'+appID)
        .set(dataInsert, () => {
          this.setState({
            isLoading : false,
            status_response : true,
            message_response : '{ ' + this.state.name + ' } gravado com sucesso!'
          });
          console.clear();
          browserHistory.push('/dashboard/apps');
        });
    }
    return false;
  };//onSubmitForm(e);
  onUpdateForm(e){
    e.preventDefault();
    let required = document.getElementsByClassName('required');
    if(required.length > 0){
      this.setState({
        isLoading : true,
        status : 'requiredInput',
        status_response : false,
        message_response : 'Por favor, preencha todos os campos corretamente.'
      });
      return false;
    }else{
      const appID = this.state.appID;
      const dataUpdate = {
        uid : this.state.uid,
        appID : appID,
        name : this.state.name,
        slug : this.state.slug,
        status: this.state.status
      };
      console.log('dataUpdate -> ',dataUpdate);
      firebase.database().ref('apps/'+appID)
        .update(dataUpdate, () => {
          this.setState({
            isLoading : false,
            appID : appID,
            content: '',
            status : 'Publicado',
            status_response : true,
            message_response : '{ ' + this.state.name + ' } gravado com sucesso!'
          });
          console.log('Update successful ',this.state.apps)
          browserHistory.push('/dashboard/apps');
        });
    }
    return false;
  };//onUpdateForm(e);
  onChangeForm(e){
    console.log('onChangeForm',e)
    if(e){
      // eslint-disable-next-line
      this.state.apps.map((page) => {
        if(page.slug === slug(e.target.value)){
          this.setState({
            appID : this.refs.appID.value,
            name : this.refs.name.value,
            slug: slug(this.refs.name.value)+'_2',
            status: this.state.status
          });
        }else{
          this.setState({
            appID : this.refs.appID.value,
            name : this.refs.name.value,
            slug: slug(this.refs.name.value),
            status: this.state.status
          });
        }
      });
    }
  };//onChangeForm(e);
  _onChangeCompanyName(e){
    if(e){
      this.setState({company_name: e.target.value});
    }
  };//_onChangeCompanyName(e);
  _onChangeSloganCompanyName(e){
    if(e){
      this.setState({company_slogan_name: e.target.value});
    }
  };//_onChangeSloganCompanyName(e);
  _onChangeUserName(e){
    if(e){
      this.setState({user_name: e.target.value});
    }
  };//_onChangeUserName(e);
  onChangeTiny(e){
    if(e)
      this.setState({ content : e.target.getContent() });
  };//onChangeTiny(e);

  changePackageDashboard(e){
    e.preventDefault();
    console.log('target -> ',e.target);
    let
      _self=this,
      packParent = e.target.parentElement.parentElement.parentElement.children[0].innerHTML,
      pack = e.target.dataset.module;
    console.log('changePackageStatus(); -> ',pack);
    console.log('changePackageStatus(); packParent -> ',packParent);

    const appID = _self.state.appID;

    _self.packages = _self.state.packages;
    switch (pack) {
      case 'appManager_status':
        _self.packages.DASHBOARD.appManager = !_self.state.packages.DASHBOARD.appManager;;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/DASHBOARD/appManager')
          .set(_self.state.packages.DASHBOARD.appManager, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'category_status':
        _self.packages.DASHBOARD.category = !_self.state.packages.DASHBOARD.category;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/DASHBOARD/category')
          .set(_self.state.packages.DASHBOARD.category, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'footer_status':
        _self.packages.DASHBOARD.footer = !_self.state.packages.DASHBOARD.footer;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/DASHBOARD/footer')
          .set(_self.state.packages.DASHBOARD.footer, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'logo_status':
        _self.packages.DASHBOARD.logo = !_self.state.packages.DASHBOARD.logo;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/DASHBOARD/logo')
          .set(_self.state.packages.DASHBOARD.logo, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'navHeader_status':
        _self.packages.DASHBOARD.navHeader = !_self.state.packages.DASHBOARD.navHeader;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/DASHBOARD/navHeader')
          .set(_self.state.packages.DASHBOARD.navHeader, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'page_status':
        _self.packages.DASHBOARD.page = !_self.state.packages.DASHBOARD.page;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/DASHBOARD/page')
          .set(_self.state.packages.DASHBOARD.page, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'product_status':
        _self.packages.DASHBOARD.product = !_self.state.packages.DASHBOARD.product;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/DASHBOARD/product')
          .set(_self.state.packages.DASHBOARD.product, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'settings_status':
        _self.packages.DASHBOARD.settings = !_self.state.packages.DASHBOARD.settings;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/DASHBOARD/settings')
          .set(_self.state.packages.DASHBOARD.settings, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      default:
        console.log('Package não encontrado! ',pack);
    }
  }//changePackageDashboard(e);

  changePackageShop(e){
    e.preventDefault();
    console.log('target -> ',e.target);
    let
      _self=this,
      packParent = e.target.parentElement.parentElement.parentElement.children[0].innerHTML,
      pack = e.target.dataset.module;
    console.log('changePackageStatus(); -> ',pack);
    console.log('changePackageStatus(); packParent -> ',packParent);

    const appID = _self.state.appID;

    _self.packages = _self.state.packages;
    switch (pack) {
      case 'cart_status':
        _self.packages.SHOP.cart = !_self.state.packages.SHOP.cart;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/SHOP/cart')
          .set(_self.state.packages.SHOP.cart, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'cartBox_status':
        _self.packages.SHOP.cartBox = !_self.state.packages.SHOP.cartBox;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/SHOP/cartBox')
          .set(_self.state.packages.SHOP.cartBox, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'footer_status':
        _self.packages.SHOP.footer = !_self.state.packages.SHOP.footer;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/SHOP/footer')
          .set(_self.state.packages.SHOP.footer, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'loginBox_status':
        _self.packages.SHOP.loginBox = !_self.state.packages.SHOP.loginBox;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/SHOP/loginBox')
          .set(_self.state.packages.SHOP.loginBox, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'productGrid_status':
        _self.packages.SHOP.productGrid = !_self.state.packages.SHOP.productGrid;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/SHOP/productGrid')
          .set(_self.state.packages.SHOP.productGrid, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'searchBox_status':
        _self.packages.SHOP.searchBox = !_self.state.packages.SHOP.searchBox;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/SHOP/searchBox')
          .set(_self.state.packages.SHOP.searchBox, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      case 'topbarHeader_status':
        _self.packages.SHOP.topbarHeader = !_self.state.packages.SHOP.topbarHeader;
        _self.setState({ packages : _self.packages });

        firebase.database().ref('apps/'+appID+'/packages/SHOP/topbarHeader')
          .set(_self.state.packages.SHOP.topbarHeader, () => {
            _self.setState({
              isLoading : false,
              status_response : true,
              message_response : '{ MODULO: '+pack+' } gravado com sucesso!'
            });
          });
        break;
      default:
        console.log('Package não encontrado! ',pack);
    }
  }//changePackageShop(e);

  changePackageSite(e){
    e.preventDefault();
    console.log('target -> ',e.target);
    let
      _self=this,
      packParent = e.target.parentElement.parentElement.parentElement.children[0].innerHTML,
      // pack = e.target.classList[0];
      pack = e.target.dataset.module;
    console.log('changePackageStatus(); -> ',pack);
    console.log('changePackageStatus(); packParent -> ',packParent);

    const appID = _self.state.appID;

    _self.packages = _self.state.packages;
    switch (pack) {
      case 'footer_status':
        _self.packages.SITE.footer = !_self.state.packages.SITE.footer;
        _self.setState({ packages : _self.packages });
        break;
      case 'logo_status':
        _self.packages.SITE.logo = !_self.state.packages.SITE.logo;
        _self.setState({ packages : _self.packages });
        break;
      case 'navHeader_status':
        _self.packages.SITE.navHeader = !_self.state.packages.SITE.navHeader;
        _self.setState({ packages : _self.packages });
        break;
      default:
        console.log('Package não encontrado! ',pack);
    }
  }//changePackageSite(e);

  onDropFile(files){
    console.log('Received files: ', files);
    this.setState({files:files});
    this.runUploadFiles(files);
  };//onDropFile(files);

  onDropFileClick(){
    console.log('this.refs.dropzone' , this.refs.dropzone)
    this.refs.dropzone.open();
  };//onDropFileClick();

  runUploadFiles(files){
    console.log('runUploadFiles');
    let
      _self=this,
      storageRef = firebase.storage().ref('apps/'+ this.state.appID +'/');

    if(files.length > 0){
      // eslint-disable-next-line
      files.map((file,key) => {
        if(key === 0){
          let fileID = TOOLS.uniqueID(),
              fileName_old = file.name,
              // fileName = fileID + '_' + fileName_old,
              fileName = _self.state.appID + '_logo_' + fileName_old,
              fileRef = storageRef.child('uploads/' + fileName),
              // pathFile = fileRef.fullPath,
              // fileSize = file.size,
              // fileType = file.type,
              uploadTask = fileRef.put(file);
              _self.setState({isLoading : true});

          uploadTask.on('state_changed', (snapshot) => {
            console.log('snapshot -> ',snapshot);
          }, (error) => {
            console.log('error -> ',error);
          }, () => {
            fileRef.getDownloadURL().then((url) => {
              _self.setState({ logoURL:url });

              firebase.database().ref('apps/'+_self.state.appID+'/appData/logoURL')
                .set(_self.state.logoURL, () => {
                  _self.setState({
                    isLoading : false,
                    status_response : true,
                    message_response : 'Logo configurada com sucesso!'
                  });
                });

            }).catch((error) => {
              console.log(error);
            });
          });

          console.log('this.state.logoURL -> ', this.state.logoURL);
          console.log('uploadTask -> ', uploadTask);
        }
      });
    }
  };//runUploadFiles();

  tabGeral(){
    return (
      <form onChange={this.onChangeForm} onSubmit={this.onSubmitForm}>
        <Col xs={12} md={8} className={'no-padding'}>
          <Col xs={12} md={6}>
            <div className={'input-group'}>
              <label>Nome da Empresa</label>
              <input
                className={'form-control no-radius'}
                type="text"
                ref="company_name"
                value={APP_CONFIG.PROJECT_NAME}
                disabled
              />
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className={'input-group'}>
              <label>Slogan da Empresa</label>
              <input
                className={'form-control no-radius'}
                type="text"
                ref="company_slogan_name"
                value={APP_CONFIG.PROJECT_SLOGAN}
                disabled
              />
            </div>
          </Col>
          <Col xs={12} md={6} style={{marginTop:10}}>
            <div className={'input-group'}>
              <label>Nome do Responsável</label>
              <input
                className={'form-control no-radius required'}
                onBlur={TOOLS.requiredInput}
                onChange={this._onChangeUserName}
                type="text"
                ref="user_name"
                placeholder="Digite o nome aqui"
              />
            </div>
          </Col>
          <Col xs={12} md={6} style={{marginTop:10}}>
            <div>
              <label>Logo</label>
              <Col xs={12} md={12} className={'no-padding'}>
                {!this.state.logoURL ?
                  <div>
                    <Dropzone ref="dropzone" className={'dropzone'} activeClassName={'dragIn'} onDrop={this.onDropFile} >
                      <span>Arraste sua logo para cá, ou clique para selecionar o arquivo.</span>
                    </Dropzone>
                    <button type="button" onClick={this.onDropFileClick} style={{display:'none'}}>
                      OpenBox
                    </button>
                  </div>
                :
                  <Image src={this.state.logoURL} responsive thumbnail />
                }
              </Col>
            </div>
          </Col>
        </Col>
        <Col xs={12} md={4} className={'no-paddingRight pull-right'}>
          <Button
            onClick={this.onSubmitForm}
            className="btn btn-success pull-right no-radius"
            >Salvar
          </Button>
          <Link
            to={'/dashboard/apps/'}
            className="btn btn-danger pull-right no-radius"
            >Cancelar
          </Link>
        </Col>
      </form>
    );
  }//tabGeral();

  tabLayout(){
    return (
      <Col xs={12} md={12} className={'no-padding'}>
        <ul className={'col-md-4'}>
          <span className={'label label-info'}>DASHBOARD</span>
            <li>
              Menu Full
              { this.state.packages.DASHBOARD.appManager ?
                <span className={'fa fa-toggle-on'} data-module={'appManager_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'appManager_status'} onClick={this.changePackageShop}></span>
              }
            </li>
        </ul>
        <ul className={'col-md-4'}>
          <span className={'label label-info'}>SHOP</span>
            <li>
              Menu Full
              { this.state.packages.DASHBOARD.appManager ?
                <span className={'fa fa-toggle-on'} data-module={'appManager_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'appManager_status'} onClick={this.changePackageShop}></span>
              }
            </li>
        </ul>
        <ul className={'col-md-4'}>
          <span className={'label label-info'}>SITE</span>
            <li>
              Menu Full
              { this.state.packages.DASHBOARD.appManager ?
                <span className={'fa fa-toggle-on'} data-module={'appManager_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'appManager_status'} onClick={this.changePackageShop}></span>
              }
            </li>
        </ul>
      </Col>
    );
  }//tabLayout();

  tabModules(){
    return (
      <Col xs={12} md={12} className={'no-padding'}>
        <ul className={'col-md-4'}>
          <span className={'label label-info'}>DASHBOARD</span>
            <li>
              AppManager
              { this.state.packages.DASHBOARD.appManager ?
                <span className={'fa fa-toggle-on'} data-module={'appManager_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'appManager_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              Category
              { this.state.packages.DASHBOARD.category ?
                <span className={'fa fa-toggle-on'} data-module={'category_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'category_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              Footer
              { this.state.packages.DASHBOARD.footer ?
                <span className={'fa fa-toggle-on'} data-module={'footer_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'footer_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              Logo
              { this.state.packages.DASHBOARD.logo ?
                <span className={'fa fa-toggle-on'} data-module={'logo_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'logo_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              NavHeader
              { this.state.packages.DASHBOARD.navHeader ?
                <span className={'fa fa-toggle-on'} data-module={'navHeader_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'navHeader_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              Page
              { this.state.packages.DASHBOARD.page ?
                <span className={'fa fa-toggle-on'} data-module={'page_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'page_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              Product
              { this.state.packages.DASHBOARD.product ?
                <span className={'fa fa-toggle-on'} data-module={'product_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'product_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              Settings
              { this.state.packages.DASHBOARD.settings ?
                <span className={'fa fa-toggle-on'} data-module={'settings_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'settings_status'} onClick={this.changePackageShop}></span>
              }
            </li>
        </ul>

        <ul className={'col-md-4'}>
          <span className={'label label-info'}>SHOP</span>
            <li>
              Cart
              { this.state.packages.SHOP.cart ?
                <span className={'fa fa-toggle-on'} data-module={'cart_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'cart_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              CartBox
              { this.state.packages.SHOP.cartBox ?
                <span className={'fa fa-toggle-on'} data-module={'cartBox_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'cartBox_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              Footer
              { this.state.packages.SHOP.footer ?
                <span className={'fa fa-toggle-on'} data-module={'footer_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'footer_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              LoginBox
              { this.state.packages.SHOP.loginBox ?
                <span className={'fa fa-toggle-on'} data-module={'loginBox_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'loginBox_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              ProductGrid
              { this.state.packages.SHOP.productGrid ?
                <span className={'fa fa-toggle-on'} data-module={'productGrid_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'productGrid_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              SearchBox
              { this.state.packages.SHOP.searchBox ?
                <span className={'fa fa-toggle-on'} data-module={'searchBox_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'searchBox_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              TopbarHeader
              { this.state.packages.SHOP.topbarHeader ?
                <span className={'fa fa-toggle-on'} data-module={'topbarHeader_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'topbarHeader_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              NavFull
              { this.state.packages.SHOP.navFull ?
                <span className={'fa fa-toggle-on'} data-module={'navFull_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'navFull_status'} onClick={this.changePackageShop}></span>
              }
            </li>
        </ul>

        <ul className={'col-md-4'}>
          <span className={'label label-info'}>SITE</span>
            <li>
              Cart
              { this.state.packages.SITE.cart ?
                <span className={'fa fa-toggle-on'} data-module={'cart_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'cart_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              CartBox
              { this.state.packages.SITE.CartBox ?
                <span className={'fa fa-toggle-on'} data-module={'CartBox_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'CartBox_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              Footer
              { this.state.packages.SITE.footer ?
                <span className={'fa fa-toggle-on'} data-module={'footer_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'footer_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              LoginBox
              { this.state.packages.SITE.loginBox ?
                <span className={'fa fa-toggle-on'} data-module={'loginBox_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'loginBox_status'} onClick={this.changePackageShop}></span>
              }
            </li>

            <li>
              ProductGrid
              { this.state.packages.SITE.productGrid ?
                <span className={'fa fa-toggle-on'} data-module={'productGrid_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'productGrid_status'} onClick={this.changePackageShop}></span>
              }
            </li>
            <li>
              NavFull
              { this.state.packages.SITE.navFull ?
                <span className={'fa fa-toggle-on'} data-module={'navFull_status'} onClick={this.changePackageShop}></span>
              :
                <span className={'fa fa-toggle-off'} data-module={'navFull_status'} onClick={this.changePackageShop}></span>
              }
            </li>
        </ul>
      </Col>
    );
  }//tabModules();

  tabExtras(){
    return (
      <Col xs={12} md={12} className={'no-padding'}>
        <h1>Extras</h1>
      </Col>
    );
  }//tabExtras();



  /*
   *	 RENDER FUNCTIONS - ACTIONS
   *
   *  Funções que renderizam a view do component,
   *  de acordo a ACTION de this.props.action;
   *  Todas as "ACTIONS Functions" definem document.name:
   *  Ex: document.name = APP_CONFIG.PROJECT_NAME + ' | Page Name';
   *  { actionNull - actionNew - actionEdit - actionDelete }
   */
  actionNull(){
    /*
     *  Responsável por renderizar a table de Páginas
     *  if( this.state.apps.length > 0 )
     */
    document.name = APP_CONFIG.PROJECT_NAME + ' | Configurações';
    if( !this.state.isLoading ){
      return (
        <div>
          <Col xs={12} md={12} className={'no-padding'}>
            <Tabs defaultActiveKey={1} className={'tabs'} id={'settingsTab'}>
              <Tab eventKey={1} title={'Geral'}>
                {this.tabGeral()}
              </Tab>
              <Tab eventKey={2} title={'Modulos'}>
                {this.tabModules()}
              </Tab>
              <Tab eventKey={3} title={'Layout'}>
                {this.tabLayout()}
              </Tab>
              <Tab eventKey={4} title={'Extras'}>
                {this.tabExtras()}
              </Tab>
            </Tabs>
          </Col>
        </div>
      );
    }else{
      return (
        <div>
          <Col xs={12} md={12} className={'no-padding'}>
            <Tabs defaultActiveKey={1} className={'tabs'} id={'settingsTab'}>
              <Tab eventKey={1} title={'Geral'}>
                {this.tabGeral()}
              </Tab>
              <Tab eventKey={2} title={'Modulos'}>
                {this.tabModules()}
              </Tab>
              <Tab eventKey={3} title={'Layout'}>
                {this.tabLayout()}
              </Tab>
              <Tab eventKey={4} title={'Extras'}>
                {this.tabExtras()}
              </Tab>
            </Tabs>
          </Col>
        </div>
      );
    }
  };//actionNull();

  renderAction(){
    /*
     *  Responsável por verificar e chamar ACTIONS.
     *  Ex: if( this.props.action === 'new' ) this.actionNew();
     */
    if( !this.props.action )
      return (<div>{this.actionNull()}</div>);
  };//renderAction();

  render(){
    return (
      <div>
        {/*this.checkStatusResponse()*/}
        {
          this.renderAction()
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Dashboard/Settings/Settings.js